export const companyInfo = {
  name: "Pedersen Byg",
  owner: "Christian Juhl Pedersen",
  address: "Skovbakkevej 2, 8870 Langå",
  phone: "+45 53 81 68 82",
  email: "pedersenbyg8840@gmail.com",
  cvr: "44687984",
  openingHours: [
    { days: "Mandag - Torsdag", hours: "07:00 - 16:00" },
    { days: "Fredag", hours: "07:00 - 14:00" },
    { days: "Lørdag - Søndag", hours: "Lukket (Akuttelefon åben)" }
  ],
  tagline: "Klassisk murerarbejde udført med stolthed og præcision",
  description: "Jeg er din lokale murer i Langå og omegn. Jeg har specialiseret mig i facade- og murværk, omfugning samt renovering af ældre ejendomme. For mig er solidt håndværk, troværdighed og glade kunder det vigtigste.",
  values: [
    {
      title: "Solidt Håndværk",
      description: "Jeg går aldrig på kompromis med kvaliteten. Jeg bygger til at holde i generationer med klassiske danske murerdyder."
    },
    {
      title: "Lokal Troværdighed",
      description: "Som din lokale murer i Langå holder jeg altid mine aftaler. Jeg er tæt på dig og rykker hurtigt ud."
    },
    {
      title: "Rent Arbejde",
      description: "Jeg rydder altid pænt op efter mig selv. Du skal kun nyde det færdige resultat – ikke bekymre dig om byggerod."
    }
  ]
};
